import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { DialogService } from '../../../../../services/dialog-service.service'

const KEY = 'message-info-dialog';

@Component({
  selector: 'app-message-info',
  templateUrl: './message-info.component.html',
  styleUrls: ['./message-info.component.scss']
})
@Stringable({
  path: 'views/partials/layout/dialogs/message-info-dialog',
  key: KEY,
})
export class MessageInfoComponent extends BaseDialogComponent implements OnInit {
  @StringableValues(KEY)
  strings: any;

  constructor(
    public dialogRef: MatDialogRef<MessageInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(dialogRef, dialogService, changeDetectorRef);
  }

  ngOnInit() {
    console.log("DIALOGMSG",this.data, this.strings);
  }
}
